var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popover',{attrs:{"title":false}},[_c('template',{slot:"content"},[_c('div',{staticClass:"p-all"},[_vm._v(" "+_vm._s(_vm.$t("Dublicate Annotation to another viewports"))+" ")])]),_c('span',{staticClass:"tool-group-btn without-arrow",class:{
      //   'tool-group-btn__active': invert,
    }},[_c('span',{staticClass:"tool-group-btn__item tool-group-btn__icon"},[_c('i',{staticClass:"fa-regular fa-clone",on:{"click":_vm.dublicateAnnotations}})])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }